export { PayrollQreLayout } from './PayrollQreLayout';
